define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.scrollTo = void 0;
    var easeInOutQuad = function (t, b, c, d) {
        var tValue = t;
        tValue /= d / 2;
        if (t < 1) {
            return (c / 2) * t * t + b;
        }
        tValue--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
    };
    var move = function (amount) {
        document.documentElement.scrollTop = amount;
        document.body.parentNode.scrollTop = amount;
        document.body.scrollTop = amount;
    };
    var position = function () {
        return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
    };
    var scrollTo = function (to, duration, callback) {
        var start = position();
        var change = to - start;
        var increment = 20;
        var currentTime = 0;
        var durationValue = duration;
        durationValue = typeof duration === 'undefined' ? 500 : duration;
        var animateScroll = function () {
            currentTime += increment;
            var val = easeInOutQuad(currentTime, start, change, duration);
            move(val);
            if (currentTime < durationValue) {
                var windowObj = window;
                windowObj.requestAnimFrame(animateScroll);
            }
            else {
                if (callback && typeof callback === 'function') {
                    callback();
                }
            }
        };
        animateScroll();
    };
    exports.scrollTo = scrollTo;
});
//# sourceMappingURL=UtilsScrollTo.js.map